.default-icon {
  height: 16px;
  color: var(--default--icon--fill-color--10);
}

.received-icon {
  height: 16px;
  color: var(--default--icon--fill-color--11);
}
